import React, { Fragment, useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
  Table,
  Button,
} from "reactstrap";
import classnames from "classnames";
import Moment from "moment";
var loginUser = JSON.parse(localStorage.getItem("user"));
const EmpAssetList = React.memo((props) => {
  const { 
    selectedItem, 
    assetList,
    handleSelectedAsset,
    handleAddBtnClick,
    isOpenAssetItems,
    handleDeleteAsset,
    employeeid

  } = props;
  const [activeTab, setActiveTab] = useState("2");
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const downloadFile = (fileName) => {
    // Construct the file URL
    const parts = fileName.split('\\');
    const fileNameN = parts[parts.length - 1];

    // Optional: Remove the .pdf extension if needed
    const pdfName = fileNameN.replace('.pdf', '');

    const pdfUrl = "/img/employee/"+fileNameN;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = fileNameN; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
  return (
    <Fragment>
      <Nav tabs>
        {/* <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => {
              toggle("1");
            }}
          >
            Software
          </NavLink>
        </NavItem> */}
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => {
              toggle("2");
            }}
          >
            Software/Hardware
          </NavLink>
        </NavItem>
      </Nav>
      <Container className="mt-2">
        <TabContent activeTab={activeTab}>
          <TabPane tabId="2">
          {/* <Row>
              <Col lg={12} md={3} sm={6} xs={12} className="mb-3 ">
              <Button outline style={{float:"right"}}
              onClick = {handleAddBtnClick}
              >Add</Button>
              </Col>
            </Row> */}
            <Row>
              <Col lg={12} md={3} sm={6} xs={12} className="mb-3 ">
                <Table striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Item Name</th>
                      <th>Item Model</th>
                      <th>Model No</th>
                      <th>Unique ID</th>
                      <th>Purchase Date</th>
                      <th>Warranty End</th>
                      <th>Vendor</th>   
                    </tr>
                  </thead>
                  <tbody>
                    {
                      // props.assetData

                      assetList
                        .filter((el) => el.employeeId == employeeid)
                        .map((itemData, i) => {
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>     
                              <td>{itemData.itemName}</td>                        
                              <td>{itemData.itemModel}</td>
                              <td>{itemData.modelNo}</td>
                              <td>{itemData.uniqueIdentificationNumber}</td>
                              <td>{Moment(itemData.purchaseDate).format("DD-MM-YYYY")}</td>
                              <td>{Moment(itemData.warrantyEndDate).format("DD-MM-YYYY")}</td>
                              <td>{itemData.vendor}</td>
                             {itemData.warrantyFilePath != '' ? (<td><Button onClick={() => downloadFile(itemData.warrantyFilePath)}>Download PDF</Button></td>) : (null)} 
                              {/* <td>
                               
                               <i
                                 className="fas fa-edit"
                                 onClick={() => {
                                   props.handleSelectedAsset(itemData, i);
                                   // props.toggle();handleDeleteAsset
                                 }}
                               ></i>
                             </td>  */}
                             {/* <td>
                            
                      <i className="fas fa-trash"
                      onClick={() => props.handleDeleteAsset(itemData)}></i>
                                               
                             </td> */}
                            </tr>
                          );
                        })
                    }
                  </tbody>
                </Table>
              </Col>
            </Row>
          </TabPane>
          {/* <TabPane tabId="1">
            <Row>
              <Col lg={12} md={3} sm={6} xs={12} className="mb-3 ">
              <Button outline style={{float:"right"}}
              onClick = {handleAddBtnClick}
              >Add</Button>
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={3} sm={6} xs={12} className="mb-3 ">
                <Table striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Item Model</th>
                      <th>Model No</th>
                      <th>Unique ID</th>
                      <th>Purchase Date</th>
                      <th>Warranty End</th>
                      <th>Vendor</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>

                    {
                      assetList
                        .filter(
                          (el) =>
                          el.itemType == 1
                          && el.employeeId == loginUser.EmployeeId
                        )
                        .map((itemData, i) => {
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{itemData.itemModel}</td>
                              <td>{itemData.modelNo}</td>
                              <td>{itemData.uniqueIdentificationNumber}</td>
                              <td>{Moment(itemData.purchaseDate).format("DD-MM-YYYY")}</td>
                              <td>{Moment(itemData.warentyEndDate).format("DD-MM-YYYY")}</td>
                              <td>{itemData.vendor}</td>
                              <td>
                               
                                <i
                                  className="fas fa-edit"
                                  onClick={() => {
                                    props.handleSelectedAsset(itemData, i);
                                    // props.toggle();
                                  }}
                                ></i>
                              </td>
                            </tr>
                          );
                        })
                    }
                  </tbody>
                </Table>
              </Col>
            </Row>
          </TabPane> */}
        </TabContent>
      </Container>
    </Fragment>
  );
});

export default EmpAssetList;
